import { uuidv4 } from "@firebase/util";

const getModifiedNameWithUuid = (file: File) => {
  const position = file.name.lastIndexOf(".");
  const uuid = uuidv4();
  const modifiedName = [
    file.name.slice(0, position),
    `_uid_${uuid}`,
    file.name.slice(position),
  ].join("");

  const blob = file.slice(0, file.size, file.type);
  return new File([blob], modifiedName, {
    type: file.type,
  });
};

export default getModifiedNameWithUuid;
